import React, { useEffect, useState } from "react";
import { Headers } from "../../../../../api/actions";
import { Api } from "../../../../../api";
import axios from "axios";
import { useParams } from "react-router";
import { useNavigate, useSearchParams } from "react-router-dom";

import swal from "sweetalert";
import axiosInstance from "../../../../../api/axios_instance";

const MultipleChoice = (props) => {
  const { Type, setType, question, setQuestion, answers } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const subjectId = searchParams.get("subjectId");

  const { id } = useParams();
  const navigate = useNavigate();

  const [answerAll, setAnswerAll] = useState(answers);
  const [error, setError] = useState(false);

  const SubmitAction = (e) => {
    if (question === "") {
      setError(true);
      swal("يجب ادخال نص السؤال", {
        icon: "warning",
        button: {
          text: "إغلاق",
          closeModal: true,
        },
      });
      return;
    } else {
      // check if the answer is correct one item only
      let correctAnswer = answerAll.filter(
        (item) => item.isCorrectAnswer === true
      );
      // check if the answer namer is empty
      let answerName = answerAll.filter((item) => item.name === "");
      if (answerName.length !== 0) {
        swal("يجب ادخال جميع الاجابات", {
          icon: "warning",
          button: {
            text: "إغلاق",
            closeModal: true,
          },
        });
        return;
      } else if (correctAnswer.length !== 1) {
        swal("يجب اختيار اجابه صحيحه واحده", {
          icon: "warning",
          button: {
            text: "إغلاق",
            closeModal: true,
          },
        });
        return;
      } else if (answerAll.length < 2) {
        swal("يجب ادخال اجاباتان ع الاقل", {
          icon: "warning",
          button: {
            text: "إغلاق",
            closeModal: true,
          },
        });
      } else {
        setError(false);
        e.preventDefault();
        SendData(Type, id, subjectId, question, answerAll, navigate);
      }
    }
  };

  return (
    <div className="add-question-content__card">
      <h6>تعديل سؤال</h6>
      {/* Question Name */}
      <textarea
        rows="3"
        value={question}
        placeholder="اكتب نص السؤال"
        name="add-question-textarea"
        required
        className={
          question === "" && error === true
            ? "form-control is-invalid"
            : "form-control"
        }
        onChange={(e) => {
          e.preventDefault();
          setQuestion(e.target.value);
        }}
      ></textarea>
      <SelectBoxTypeAnswer Type={Type} setType={setType} />
      <>
        {answerAll.map((item, index) => {
          return (
            <MultipleChoiceInputRow
              key={item.answerId}
              setAnswerAll={setAnswerAll}
              answerAll={answerAll}
              Item={item}
              Index={index}
            />
          );
        })}
        <AddInput setAnswerAll={setAnswerAll} answerAll={answerAll} />
        <ButtonsAll SubmitAction={SubmitAction} />
      </>
    </div>
  );
};

export default MultipleChoice;

const SelectBoxTypeAnswer = (props) => {
  const { Type, setType } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    GetData(setData, setLoading);
  }, []);
  if (loading === false) {
    return (
      <div className="select-box">
        <label htmlFor="">نوع السؤال</label>
        <input
          type="text"
          name=""
          id=""
          className={" form-control"}
          value={"جاري التحميل"}
        />
      </div>
    );
  }
  return (
    <div className="select-box" style={{ position: "relative" }}>
      <div
        style={{
          position: "absolute",
          left: "20px",
          bottom: "50px",
          color: "gray",
        }}
      >
        ⮟
      </div>
      <label htmlFor="">نوع السؤال</label>
      <select
        name=""
        id=""
        className={"form-control"}
        defaultValue={Type}
        onChange={(e) => {
          e.preventDefault();
          setType(e.target.value);
        }}
        disabled={true}
      >
        {data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.nameAr}
            </option>
          );
        })}
      </select>
    </div>
  );
};

const MultipleChoiceInputRow = (props) => {
  const { setAnswerAll, answerAll, Item, Index } = props;
  const [value, setValue] = useState(Item.name);
  const [select, setSelect] = useState(Item.isCorrectAnswer);

  const SelectArray = [
    {
      id: 1,
      value: true,
      name: "صحيح",
    },
    {
      id: 2,
      value: false,
      name: "خطأ",
    },
  ];

  const onChingeSelect = (e) => {
    e.preventDefault();
    setSelect(!select);
    Item.isCorrectAnswer = !select;
    answerAll[Index] = Item;
    setAnswerAll([...answerAll]);
  };

  const onChingeInput = (e) => {
    e.preventDefault();
    setValue(e.target.value);
    Item.name = e.target.value;
    answerAll[Index] = Item;
    setAnswerAll([...answerAll]);
  };

  const RemoveInput = (e) => {
    e.preventDefault();
    // answerAll.splice(Index, 1);
    setAnswerAll((prv) => prv.filter((itm, idx) => idx !== Index));
  };
  return (
    <div className="multiple-choice__row">
      <div className="select">
        <label htmlFor="">حاله الأجابه </label>
        <select
          name=""
          id=""
          value={select}
          className={select === true ? "success" : "error"}
          onChange={onChingeSelect}
        >
          {SelectArray.map((item, index) => {
            return (
              <option key={index} value={item.value}>
                {item.name}
              </option>
            );
          })}
        </select>
      </div>
      <div className="inputs">
        <label htmlFor="">الأجابه</label>
        <input
          type="text"
          name=""
          id=""
          className={
            select === true ? "success form-control" : "error form-control"
          }
          value={value}
          onChange={onChingeInput}
        />
      </div>
      {Index === 0 ? null : (
        <button type="button" className="btn btn-remove" onClick={RemoveInput}>
          <span>حذف</span>
        </button>
      )}
    </div>
  );
};

const ButtonsAll = (props) => {
  const { SubmitAction } = props;
  const navigate = useNavigate();

  return (
    <div className="add-question-content__card__buttons">
      <button
        type="button"
        className="btn btn-save"
        onClick={(e) => {
          SubmitAction(e);
        }}
      >
        <span>حفظ</span>
      </button>
      <button
        type="button"
        className="btn btn-cansal"
        onClick={(e) => {
          e.preventDefault();
          navigate(-1);
        }}
      >
        <span>الغاء</span>
      </button>
    </div>
  );
};
const AddInput = (props) => {
  const { setAnswerAll, answerAll } = props;

  const AddInput = (e) => {
    e.preventDefault();
    if (answerAll.length >= 4) {
      return false;
    } else {
      answerAll.push({
        answerId: Math.random() * 1000,
        name: "",
        isCorrectAnswer: false,
      });
      setAnswerAll([...answerAll]);
    }
  };
  return (
    <div className="multiple-choice__addInput">
      <button
        type="button"
        disabled={answerAll.length >= 4 ? true : false}
        className="btn button button-next"
        onClick={AddInput}
      >
        أضافه أختيار جديد
      </button>
    </div>
  );
};

// Send Data to API
const SendData = async (Type, id, SubjectId, question, answerAll, navigate) => {
  var Formdata = new FormData();
  for (var i = 0; i < answerAll.length; i++) {
    Formdata.append(`answers[${i}].name`, JSON.stringify(answerAll[i].name));
    Formdata.append(
      `answers[${i}].isCorrectAnswer`,
      answerAll[i].isCorrectAnswer
    );
  }

  const options = {
    method: "post",
    url: `${Api}Question/AddEditQuestion`,
    headers: Headers,
    data: {
      id,
      name: question,
      SubjectId: SubjectId,
      answerTypeId: Number(Type),
      answers: answerAll,
    },
  };
  await axiosInstance(options)
    .then(function (response) {
      if (response.data.responseStatus.description === "Error")
        swal(
          response.data.responseStatus.errors
            .map((err) => err.errorMessage)
            .join("\n"),
          {
            icon: "error",
            button: {
              text: "إغلاق",
              closeModal: true,
            },
          }
        ).then((result) => {
          if (result === true) {
            navigate(-1);
          }
        });
      else
        swal("تم تعديل سؤال بنجاح", {
          icon: "success",
          button: {
            text: "إغلاق",
            closeModal: true,
          },
        }).then((result) => {
          if (result === true) {
            navigate(-1);
          }
        });
    })
    .catch(function (error) {});
};

const GetData = async (setData, setLoading) => {
  const options = {
    method: "GET",
    url: `${Api}AnswerType/GetAnswerTypes`,
    headers: Headers,
  };
  await axiosInstance(options)
    .then(function (response) {
      setData(response.data.responseObject);
      setLoading(true);
    })
    .catch(function (error) {
      setLoading(true);
    });
};
